import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { StoreDeliveryCodeEnum } from '../../../enums';
import { IStoresListCallback } from '../../../interfaces';
import { StoreCardComponent } from '../../store-card/store-card.component';
import { PickupStrategyPresenter } from './pickup-strategy.presenter';
import { IPickupStrategyComponent, IPickupStrategyPresenter } from './interfaces';

@Component({
	selector: 'app-pickup-strategy',
	templateUrl: './pickup-strategy.component.html',
	providers: [PickupStrategyPresenter],
	standalone: true,
	imports: [CommonModule, StoreCardComponent],
})
export class PickupStrategyComponent
	extends IAbstractView<IPickupStrategyPresenter>
	implements IPickupStrategyComponent
{
	@Input() stores: StoreModel[] = [];
	@Input() translations: ILanguageObject = {};
	@Input({ required: true }) callback!: IStoresListCallback;

	readonly StoreDeliveryCodeEnum = StoreDeliveryCodeEnum;

	constructor(presenter: PickupStrategyPresenter) {
		super(presenter);
	}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.presenter.onSelectStore(store, code);
	}
}
